<div>
  <div class="row-no-margin">
    <div class="col-md-6">
      <span class="section-header">Info Center</span>
    </div>
    <div class="col-md-5" style="text-align:right;">
      <button class="blue" (click)="AddNewFile()" value="New File">New File</button>
    </div>
    
  </div>
  <div>
    <div *ngFor="let file of FileList" class="infoCenterTile row-no-margin">
      <!--Filename-->
      <div class="col-md-4 clear-padding">
        <span style="font-size:15px;line-height:20px;">Updated {{file.UpdateDate | date: 'short'}}</span>
        <br />
        <span style="font-size:17px; line-height:20px;font-weight:500;">{{file.FileName}}</span>
      </div>
      <!--File Type/Category-->
      <div class="col-md-2 clear-padding" style="text-align:center;">
        <span style="font-size:15px;line-height:20px;font-weight:600;">Doc type</span>
        <br />
        <span>{{file.Category}}</span>
      </div>
      <div class="col-md-2 clear-padding" style="text-align:center;">
        <span style="font-size:15px;line-height:20px;font-weight:600;">Status</span>
        <br />
        <span [ngClass]="{'green': file.Active, 'red':!file.Active }">{{file.Active ? "Active" : "Inactive"}}</span>
      </div>
      <div class="col-md-4 clear-padding" style="text-align:right;">        
        <img alt="download"  class="clickable" (click)="DownloadFile(file)" src="./assets/images/icon-downloads-blue.svg" />
      </div>
    </div>
    <!--<table style="width:100%;">
    <tr>
      <th>Description</th>
      <th>Link</th>
      <th>Category</th>
      <th>File Type</th>
      <th>Actions</th>
    </tr>
    <ng-container *ngFor="let file of FileList">
      <tr>
        <td>
          {{file.Description}}
        </td>
        <td>
          {{file.Link}}
        </td>
        <td>
          {{file.Category}}
        </td>
        <td>
          {{file.FileType}}
        </td>
        <td>-->
    <!--Actions-->
    <!--</td>

      </tr>
    </ng-container>
  </table>-->
    <mat-paginator [length]="ItemCount" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions" (page)="PageEvent($event)">
    </mat-paginator>
  </div>
</div>
<app-modal [hidden]="true"></app-modal>
